import { Customer } from './customer.types';
import { Service } from './service.types';
import { UserAttributes } from './user.types';

export type AppointmentStatus =
  | 'booked'
  | 'confirmed'
  | 'checked_in'
  | 'completed'
  | 'cancelled'
  | 'no_show';

export const APPOINTMENT_STATUSES: AppointmentStatus[] = [
  'booked',
  'confirmed',
  'checked_in',
  'completed',
  'cancelled',
  'no_show',
];

export const TERMINAL_APPOINTMENT_STATUSES: AppointmentStatus[] = [
  'completed',
  'cancelled',
  'no_show',
];

export const STATUS_LABELS: Record<AppointmentStatus, string> = {
  booked: 'Booked',
  confirmed: 'Confirmed',
  checked_in: 'Checked In',
  completed: 'Completed',
  cancelled: 'Cancelled',
  no_show: 'No Show',
};

export interface IAppointmentService {
  id: string;
  appointment_id: string;
  serviceId: string;
  employeeId: string;
  status: string;
  priceAtBooking?: number;
  serviceName?: string;
  durationMinutes?: number;
  service?: Service;
  employee?: UserAttributes;
}

export interface IAppointment {
  id: string;
  customerId: string;
  appointment_date: string;
  status: AppointmentStatus;
  bookedBy: string;
  booked_by_user_id?: string;
  subtotal?: number;
  discountAmount?: number;
  totalBill: number;
  amountReceived?: number | null;
  tips?: number;
  paymentAdjustment?: number | null;
  version?: number;
  offerId?: string;
  notes?: string;
  completedAt?: string;
  cancelledAt?: string;
  cancellationReason?: string;
  services?: IAppointmentService[];
  customer?: Customer;
  viewToken?: string;
}

export interface IAppointmentHistoryEntry {
  id: string;
  appointmentId: string;
  version: number;
  changeType: string;
  changedByUserId?: string;
  changedByRole: string;
  changeSource: string;
  changedAt: string;
  changes: Array<{ field: string; old: unknown; new: unknown }>;
  snapshot: Record<string, unknown>;
  changeReason?: string;
  changedBy?: { id: string; firstName: string; lastName: string; email?: string };
}

export interface IPublicAppointment {
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  serviceId: string;
  employeeId?: string;
  appointmentDate: string;
  appointmentTime: string;
  notes?: string;
}
